import { useState, useEffect } from "react";

const usePyramid = (enableGhosts = true) => {
  const [ghostPlayers, setGhostPlayers] = useState([]);
  const [isLoadingGhosts, setIsLoadingGhosts] = useState(false);

  useEffect(() => {
    if (!enableGhosts) {
      setGhostPlayers([]);
      return;
    }

    const fetchStandings = async () => {
      setIsLoadingGhosts(true);
      try {
        const res = await fetch('https://flowliga.uber.space/api/fightclub/standings');
        if (!res.ok) throw new Error('standings fetch failed');
        const data = await res.json();

        if (data.ok && Array.isArray(data.players)) {
          const rankToLevel = (rank) => {
            if (rank <= 4) return 1;
            if (rank <= 12) return 2;
            if (rank <= 28) return 3;
            if (rank <= 60) return 4;
            return 5;
          };

          // Nur obere FL-Ränge als Ghost-Hinweis (nicht alle 112)
          const ghosts = data.players
            .filter((p) => p.fl_rank <= 60)
            .map((p) => ({
              _id: `ghost_${p.fl_rank}`,
              username: p.username,
              discord: p.discord,
              fl_rank: p.fl_rank,
              level: rankToLevel(p.fl_rank),
              isGhost: true,
              active: false,
            }));
          setGhostPlayers(ghosts);
        }
      } catch (err) {
        console.warn('Could not load FL standings:', err);
        setGhostPlayers([]);
      } finally {
        setIsLoadingGhosts(false);
      }
    };

    fetchStandings();
  }, [enableGhosts]);

  return { ghostPlayers, isLoadingGhosts };
};

export default usePyramid;
